// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2C5ra","content":"LoadingAlert_content__1MRCS"};